import React, { useState, useRef, useCallback, useEffect } from 'react';
import { Button, Grid, CircularProgress, Checkbox, FormControlLabel, Typography, IconButton } from '@mui/material';
import HtmlRenderer from "./components/HtmlRenderer";
import SendIcon from '@mui/icons-material/Send';
import FetchUserData from './components/fetchUserData';
import LanguageSelect from './components/LanguageSelect';
import TextToneSelect from './components/TextToneSelect';
import TextLengthSelect from './components/TextLengthSelect';
import TextareaAutosizeWithError from './components/TextareaAutosizeWithError';
import DialogComponent from './provision-app/components/dialogComponent';
import ActionSelect from './components/ActionSelect';
import InfoIcon from '@mui/icons-material/Info';
import ReactGA from "react-ga4";
import { jwtDecode } from 'jwt-decode';
// import SettingsBrightnessIcon from '@mui/icons-material/SettingsBrightness';

function PsaAiBot({ toggleTheme }) {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    const [ticketId] = useState(params.id || '');
    const [selectFieldValue, setSelectFieldValue] = useState('');
    const [apiResponse, setApiResponse] = useState('');
    const [selectFieldError, setSelectFieldError] = useState(false);
    const [textAreaError, setTextAreaError] = useState(false);
    const [includeInternalNotes, setIncludeInternalNotes] = useState(false);
    const [includeResolutionNotes, setIncludeResolutionNotes] = useState(false);
    const [includeTimeEntries, setIncludeTimeEntries] = useState(true);
    const [lastContactNote, setLastContactNote] = useState(true);
    const [generateEmail, setGenerateEmail] = useState(false);
    const [typeId, setTypeId] = useState('');
    const [subtypeId, setSubtypeId] = useState('');
    const [itemId, setItemId] = useState('');
    const [boardId, setBoardId] = useState(''); 
    const [priorityId, setPriorityId] = useState('');
    const [teamId, setTeamId] = useState('');
    const [agreementId, setAgreementId] = useState('');
    const [loading, setLoading] = useState(false);   
    const [sentiment, setSentiment] = useState('');
    const [sentimentRating, setsentimentRating] = useState('');
    const [isCloud, setIsCloud] = useState(false);
    const [isEntitled, setIsEntitled] = useState(true);
    const [showForm, setShowForm] = useState(true);
    const [showHtmlRenderer, setShowHtmlRenderer] = useState(false);
    const [userTextValue, setuserTextValue] = useState('');
    const [selectedLanguage, setSelectedLanguage] = useState('English');
    const [selectLangError, setSelectLangError] = useState(false);
    const [selectedTextLength, setSelectedTextLength] = useState('default');
    const [selectTextLengthError, setSelectTextLengthError] = useState(false);
    const [selectedTextTone, setSelectedTextTone] = useState('default');
    const [selectTextToneError, setSelectTextToneError] = useState(false);
    const textAreaRef = useRef(null);
    const apiUrl = process.env.REACT_APP_API_URL_PROD || '';
    const excludeNoteFields = ['search_university', 'recommend_solution_history', 'ticket_sentiment', 'sanitize_text', 'translate_text','similar_tickets_history'];
    const includeTranslation = ['summarize_ticket','recommend_solution','best_solutions','generate_rca','email_response','translate_text', 'sanitize_text'];
    const includeLength = ['summarize_ticket','generate_rca','email_response', 'sanitize_text'];
    const includeTone = ['summarize_ticket','generate_rca','email_response','sanitize_text'];
  
    // Fetch user data and createdCwApi from Manage Hosted Pod API
    const fetchUserDataResult = FetchUserData({ setLoading });
    const { userData, createdCwApi, showError } = fetchUserDataResult;

    //const [entitlementsFetched, setEntitlementsFetched] = useState(false);
    const [companyInfoFetched, setCompanyInfoFetched] = useState(false);

    // useEffect(() => {
    //     if (!entitlementsFetched && userData && userData.companyId !== "ciosupport") {
    //         console.log("useEffect for entitlements called");
    //         try {
    //             fetch('/api/check_entitlement', {
    //                 method: 'POST',
    //                 headers: {
    //                     'Content-Type': 'application/json',
    //                     'Access-Control-Allow-Origin': '*',
    //                 },
    //                 body: JSON.stringify({ userData: userData }, null, 2),
    //             })
    //             .then(response => response.json())
    //             .then(data => {
    //                 if (data.statusCode === 400) {
    //                     const message = JSON.parse(data.body);
    //                     if (message === "CW SSO Token is missing.") {
    //                         setIsEntitled(false);
    //                         console.error("CW SSO Token is missing.");
    //                     }
    //                 } else {
    //                     setEntitlementsFetched(true);
    //                     setIsEntitled(true);
    //                     console.log("Entitlement Response: ", data);
    //                 }
    //             })
    //             .catch((error) => {
    //                 setIsEntitled(false);
    //                 console.error('Error getting entitlements:', error);
    //             });
    //         } catch (err) {
    //             setIsEntitled(false);
    //             console.error("Error calling entitlements service: ", err);
    //         }
    //     }
    // // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [userData]);

    useEffect(() => {
        if (!companyInfoFetched && userData) {
            console.log("useEffect to check isCloud");
            const siteId = userData.siteId;
            if (siteId && siteId.includes('myconnectwise.net')) { 
                setCompanyInfoFetched(true);
                setIsCloud(true);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userData]);

    const handleSelectFieldChange = (event) => {
        setSelectFieldValue(event.target.value);
        setSelectFieldError(false);
        setSelectLangError(false);
        setTextAreaError(false);
        setuserTextValue('');
    };

    const [showModal, setShowModal] = useState({
        open: false,
        title: '',
        description: '',
        children: null,
    });

    function isTokenExpired(token) {
        try {
            const decodedToken = jwtDecode(token);
            if (!decodedToken || !decodedToken.exp) {
                return true; // If the token is invalid or doesn't have an exp claim, consider it expired
            }
            const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
            return decodedToken.exp < currentTime;
        } catch (error) {
            console.error('Error decoding token:', error);
            return true; // If there's an error decoding the token, consider it expired
        }
    }

    const refreshToken = useCallback((createdCwApi) => {
        console.log('SideKick - Refreshing token');
        return new Promise((resolve, reject) => {
            if (createdCwApi) {
                createdCwApi.post({ "request": "refreshssoaccess", "args": {} }, (data) => {
                    if (data && data.ssoAccessToken) {
                        console.log('SideKick - Token refreshed: ', data.ssoAccessToken);
                        const isTokenStringified = data.ssoAccessToken.startsWith('"') && data.ssoAccessToken.endsWith('"');
                        resolve(isTokenStringified ? JSON.parse(data.ssoAccessToken) : data.ssoAccessToken); // Resolve the promise with the new token
                    } else {
                        console.error('SideKick - Failed to refresh token');
                        reject(new Error('SideKick - Failed to refresh token')); // Reject the promise with an error
                    }
                });
            } else {
                reject(new Error('SideKick - createdCwApi is not defined')); // Reject the promise if createdCwApi is not defined
            }
        });
    }, []);

    const handleClick = (event) => {
        event.preventDefault();
        console.log("Inside handleClick: ", selectFieldValue, selectedLanguage);

        if (selectFieldValue === '') {
            setSelectFieldError(true);
        } 
        if (selectedLanguage === '') {
            setSelectLangError(true);
        }  
        if ((selectFieldValue === 'sanitize_text' && textAreaRef.current.value.trim() === '') || (selectFieldValue === 'translate_text' && textAreaRef.current.value.trim() === '')) {
            setTextAreaError(true);
        } else 
        { 
            setTextAreaError(false);
        }
        setApiResponse('');
        if (ticketId !== '' && selectFieldValue !== '' && !selectFieldError && !textAreaError && !selectLangError && userData !== null) {
            setLoading(true);
            try {
                ReactGA.event({
                    category: "Ticket",
                    action: "SideKick Action",
                    label: selectFieldValue,
                    companyId: userData.companyId,
                });

                if (userData.ssoAccessToken) {
                    // Check if token has expired and refresh if necessary
                    if (isTokenExpired(userData.ssoAccessToken)) {
                        console.log('SideKick - Token expired: ', userData.ssoAccessToken);
                        refreshToken(createdCwApi)
                            .then(newToken => {
                                console.log('SideKick - New sso token:', newToken);
                                userData.ssoAccessToken = newToken; // Update with the new token
                            })
                            .catch(error => {
                                console.error('SideKick - Failed to refresh token:', error);
                            });
                    } 
                }

                fetch(apiUrl + '/api/run_script', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                },
                body: JSON.stringify({ ticketId: ticketId, select: selectFieldValue, userText: userTextValue, selectedLanguage: selectedLanguage, includeInternalNotes: includeInternalNotes, includeResolutionNotes: includeResolutionNotes, includeTimeEntries: includeTimeEntries, textLength: selectedTextLength, textTone: selectedTextTone, userData: userData, generateEmail: generateEmail, lastContactNote: lastContactNote }, null, 2),
                })
                .then((response) => response.json())
                .then((data) => {
                    /* const newData = decodeURI(data["response"]); 
                    setApiResponse(newData); */
                    setApiResponse(data["response"]);
                    setLoading(false);
                    setShowForm(false);
                    setShowHtmlRenderer(true);
                    if (selectFieldValue === "categorize_ticket") {
                        setTypeId(data["type_id"]);
                        setSubtypeId(data["subtype_id"]);
                        setItemId(data["item_id"]);
                    }
                    if (selectFieldValue === "recommend_priority") {
                        setPriorityId(data["priority_id"]);
                    }
                    if (selectFieldValue === "recommend_board") {
                        setBoardId(data["board_id"]);
                    }
                    if (selectFieldValue === "recommend_team") {
                        setTeamId(data["team_id"]);
                    }
                    if (selectFieldValue === "ticket_sentiment") {
                        setSentiment(data["sentiment"]);
                        setsentimentRating(data["rating"]);
                    }
                    if (selectFieldValue === "recommend_agreement") {
                        setAgreementId(data["agreement_id"]);
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                    setLoading(false);
                });
            } catch (err) {
                console.log(err);
            }
        } else { 
        console.log("Error: ", selectFieldValue, selectFieldError, textAreaError, selectLangError, userData);
        setShowModal({
            open: true,
            title: 'Error:',
            description: 'There was an error loading the pod, please close the pod and re-open it.',
            children: '', 
        });
        }
    };

    const handleAddNoteClick = (html, resolution) => {
        try {
        fetch(apiUrl + '/api/add_note', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify({ ticketId: ticketId, userData: userData, noteText: html, resolution: resolution }, null, 2),
        })
            .then(() => {
            createdCwApi.post({ "request": "refreshScreen", "args": {} });
            })
            .catch((error) => {
            console.error('Error Adding Note:', error);
            });
        } catch (err) {
        console.log("Error calling add_note: ", err);
        }
    };

    const handleAddType = (html) => {
        try {
        fetch(apiUrl + '/api/update_ticket_type', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify({ ticketId: ticketId, userData: userData, typeId: typeId, subtypeId: subtypeId, itemId: itemId }, null, 2),
        })
            .then(() => {
            console.log("Ticket Updated with Type, SubType, Item: ", typeId, subtypeId, itemId)
            createdCwApi.post({ "request": "refreshScreen", "args": {} });
            })
            .catch((error) => {
            console.error('Error updating ticket type:', error);
            });
        } catch (err) {
        console.log("Error calling update_ticket_type: ", err);
        }
    };

    const handleAddPriority = (html) => {
        try {
        fetch(apiUrl + '/api/update_ticket_priority', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify({ ticketId: ticketId, userData: userData, priorityId: priorityId }, null, 2),
        })
            .then(() => {
            console.log("Ticket Updated with Priority: ", priorityId);
            createdCwApi.post({ "request": "refreshScreen", "args": {} });
            })
            .catch((error) => {
            console.error('Error updating ticket priority:', error);
            });
        } catch (err) {
        console.log("Error calling update_ticket_priority: ", err);
        }
    
    };

    const handleAddBoard = (html) => {
        try {
        fetch(apiUrl + '/api/update_ticket_board', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify({ ticketId: ticketId, userData: userData, boardId: boardId }, null, 2),
        })
            .then(() => {
            createdCwApi.post({ "request": "refreshScreen", "args": {} });
            })
            .catch((error) => {
            console.error('Error updating ticket board:', error);
            });
        } catch (err) {
        console.log("Error calling update_ticket_board: ", err);
        }
    };

    const handleAddTeam = (html) => {
        try {
        fetch(apiUrl + '/api/update_ticket_team', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify({ ticketId: ticketId, userData: userData, teamId: teamId }, null, 2),
        })
            .then(() => {
            console.log("Ticket Updated with Board: ", teamId);
            createdCwApi.post({ "request": "refreshScreen", "args": {} });
            })
            .catch((error) => {
            console.error('Error updating ticket team:', error);
            });
        } catch (err) {
        console.log("Error calling update_ticket_team: ", err);
        }
    };

    const handleAddAgreement = (html) => {
        try {
        fetch(apiUrl + '/api/update_ticket_agreement', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify({ ticketId: ticketId, userData: userData, agreementId: agreementId }, null, 2),
        })
            .then(() => {
            console.log("Ticket Updated with Agreement: ", agreementId);
            createdCwApi.post({ "request": "refreshScreen", "args": {} });
            })
            .catch((error) => {
            console.error('Error updating ticket agreement:', error);
            });
        } catch (err) {
        console.log("Error calling update_ticket_agreement: ", err);
        }
    };

    const handleAddTitle = (html) => {
        try {
            fetch(apiUrl + '/api/update_title', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify({ ticketId: ticketId, userData: userData, ticketTitle: html }, null, 2),
            })
            .then(() => {
                createdCwApi.post({ "request": "refreshScreen", "args": {} });
            })
            .catch((error) => {
                console.error('Error updating ticket summary:', error);
            });
        } catch (err) {
            console.log("Error calling update_title: ", err);
        }
    };

    const handleUpdateSentiment = (html) => {
        try {
            fetch(apiUrl + '/api/update_ticket_sentiment', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify({ ticketId: ticketId, userData: userData, overallScore: sentimentRating }, null, 2),
            })
            .then(() => {
                createdCwApi.post({ "request": "refreshScreen", "args": {} });
            })
            .catch((error) => {
                console.error('Error updating ticket sentiment:', error);
            });
        } catch (err) {
            console.log("Error calling update_ticket_sentiment: ", err);
        }
    };


    const handleOpenWindow = (html) => {
        const stateParam = {
            timeEntrySelectedState: {
                memberId: userData.memberId,
                srRecID: ticketId,
                isPopOut: true,
                openFrom: "service",
                chkContact: true,
                chkResource: true,
                chkAdditionalContact: false,
                overnight: false,
                pagerEnabled: false,
                notes: html
            },
            timeEntryOpenedContext: "Service"
        };
        const encodedState = encodeURIComponent(JSON.stringify(stateParam));
        userData.siteId = userData.siteId.replace(/\/$/, '');
        const url = `${userData.siteId}${userData.codeBase}/timeexpensemodule.html?fullscreen=true&locale=en_US&screenId=time_entry&state=${encodedState}`;
        if (url.length > 2100) {
            console.error("URL exceeds maximum character limit");
            handleClear();
            setShowModal({
                open: true,
                title: 'Error:',
                description: 'The content is too long to add a time entry note.  Please copy and paste it manually.',
                children: '', 
            });
            //throw new Error("URL exceeds maximum character limit");
        } 
        else {
            const windowFeatures = "menubar=no,location=no,resizable=yes,scrollbars=yes,status=yes,width=800,height=900";
            window.open(url, "_blank", windowFeatures);
        }
    }

    const handleOpenInfo = (html) => {
        const displayText = (
            <ul style={{margin: 0}}>
                <li>Ticket Sentiment Pod: Allows user to click the “Regenerate” button to update the overall Sentiment Score on the ticket and to generate additonal history in the graph.</li>
                <li>Added “Last Contact Note” option to Produce Email action.</li>
                <li>Japanese has been added to the translation options.</li>         
            </ul>
        );
        setShowModal({
            open: true,
            title: 'Recent Sidekick Updates:',
            description: displayText,
            children: '', 
        });
    }


    const handleInputChange = (event) => {
        setuserTextValue(event.target.value);
        setTextAreaError(false);
    }

    const handleLanguageChange = (event) => {
        setSelectedLanguage(event.target.value);
        setSelectLangError(false);
    };


    const handleTextLengthChange = (event) => {
        setSelectedTextLength(event.target.value);
        setSelectTextLengthError(false);
    };

    const handleTextToneChange = (event) => {
        setSelectedTextTone(event.target.value);
        setSelectTextToneError(false);
    };

    const handleClear = () => {
        setShowForm(true);
        setShowHtmlRenderer(false);
        setApiResponse('');
        setSentiment('');
        setsentimentRating('');
        setTextAreaError(false);
        setSelectFieldError(false);
        setSelectLangError(false);
        setSelectedLanguage('English');
    };

  return (
    <Grid container spacing={2} rowSpacing={2} columnSpacing={2} sx={{ padding: '10px 15px 0px 15px' }} direction="column">
        {/* <Grid item xs={12}>
            <Button onClick={toggleTheme} startIcon={<SettingsBrightnessIcon />}>Toggle Dark Mode</Button>
        </Grid> */}
        <Grid item xs={12} style={{ display: 'flex', alignItems: 'center', paddingTop: 0, paddingBottom: '5px' }}>
            <Typography variant="body2" style={{ flexGrow: 0, marginRight: 10 }}>Ticket: {ticketId} {userData && userData.ssoAccessToken ? ' - (Logged in with CW SSO)' : ' - (Not Logged in with CW SSO)'} </Typography>  
            <IconButton aria-label="Open Info" size="small">
                <InfoIcon fontSize="medium" onClick={handleOpenInfo} color="primary"/>
            </IconButton>         
        </Grid>
        {showError && (
            <Grid item xs={12}>
                <div>Error: Failed to fetch user data or entitlements missing. Close the pod and re-open it.</div>
            </Grid>
        )}
        {!showError && loading && !showForm && (
            <div style={{ textAlign: 'center' }}>
                <CircularProgress />
            </div>
        )}
        {!showError && !loading && !isEntitled && (
            <Grid item xs={12}>
                <div>Error: Entitlements missing or not logged in with CW SSO.</div>
            </Grid>
        )}
        {showForm && !showError && !loading && isEntitled && 
            <>
            <Grid item xs={9}>
                <ActionSelect
                    selectFieldValue={selectFieldValue}
                    handleSelectFieldChange={handleSelectFieldChange}
                    selectFieldError={selectFieldError}
                    userData={userData}
                    isCloud={isCloud}
                />
            </Grid>
            <Grid item xs={12}>
                {!excludeNoteFields.includes(selectFieldValue) ? (
                    <FormControlLabel
                        control={<Checkbox
                        checked={includeInternalNotes}
                        onChange={(e) => setIncludeInternalNotes(e.target.checked)}
                        value={includeInternalNotes} />}
                        label="Include internal notes"
                        style={{ display: (selectFieldValue === 'ticket_sentiment' || selectFieldValue === 'email_response') ? 'none' : 'inline-flex' }} 
                    />
                ) : null}
                {!excludeNoteFields.includes(selectFieldValue) ? (
                    <FormControlLabel
                        control={<Checkbox
                        checked={includeResolutionNotes}
                        onChange={(e) => setIncludeResolutionNotes(e.target.checked)}
                        value={includeResolutionNotes} />}
                        label="Include resolution notes"
                        style={{ display: (selectFieldValue === 'ticket_sentiment' || selectFieldValue === 'email_response') ? 'none' : 'inline-flex' }} 
                    />
                ) : null}
                {!excludeNoteFields.includes(selectFieldValue) ? (
                    <FormControlLabel 
                        control={<Checkbox
                        checked={includeTimeEntries}
                        onChange={(e) => setIncludeTimeEntries(e.target.checked)}
                        value={includeTimeEntries} />}
                        label="Include time entries"
                        style={{ display: (selectFieldValue === 'ticket_sentiment' || selectFieldValue === 'email_response') ? 'none' : 'inline-flex' }} 
                    />
                ) : null}
                {!excludeNoteFields.includes(selectFieldValue) ? (
                    <FormControlLabel 
                        control={<Checkbox
                        checked={lastContactNote}
                        onChange={(e) => setLastContactNote(e.target.checked)}
                        value={lastContactNote} />}
                        label="Respond to last contact note"
                        style={{ display: selectFieldValue === 'email_response' ? 'inline-flex' : 'none' }} 
                    />
                ) : null}
                <Typography style={{ display: selectFieldValue !== 'ticket_sentiment' ? 'none' : 'block' }}>Ticket Sentiment is only derived from Contact Notes.</Typography>
            </Grid >
            {selectFieldValue === 'sanitize_text' && ( 
                <>
                    <Grid item xs={10}>
                        <TextareaAutosizeWithError
                        aria-label="Clean Text"
                        placeholder="Enter Text to Sanitize Here"
                        value={userTextValue}
                        onChange={handleInputChange}
                        error={textAreaError}
                        ref={textAreaRef}
                        />
                    </Grid>
                    <Grid item xs={10}>
                        <FormControlLabel
                            control={<Checkbox
                            checked={generateEmail}
                            onChange={(e) => setGenerateEmail(e.target.checked)}
                            value={generateEmail} />}
                            label="Respond as an email to the ticket contact." 
                        />
                    </Grid>
                </>
            )}
            {selectFieldValue === 'translate_text' && ( 
                <Grid item xs={10}>
                    <TextareaAutosizeWithError
                        aria-label="Translate Text"
                        placeholder="Enter Text to Translate Here"
                        value={userTextValue}
                        onChange={handleInputChange}
                        error={textAreaError}
                        ref={textAreaRef}
                    />
                </Grid>
            )}
            {selectFieldValue === 'search_university' && ( 
                <Grid item xs={10}>
                    <TextareaAutosizeWithError
                        aria-label="Search ConnectWise University"
                        placeholder="Enter Text to Search University"
                        value={userTextValue}
                        onChange={handleInputChange}
                        error={textAreaError}
                        ref={textAreaRef}
                    />
                </Grid>
            )}
            <Grid container direction="row" spacing={2} rowSpacing={2} columnSpacing={2} sx={{ padding: 2 }}>
                {includeTranslation.includes(selectFieldValue) ? (
                    <Grid item xs={3}>
                        <LanguageSelect
                            label="Translation:"
                            value={selectedLanguage}
                            onChange={handleLanguageChange}
                            error={selectLangError}
                            fullWidth={false}
                        />
                    </Grid>
                ) : null}
                {includeLength.includes(selectFieldValue) ? (
                    <Grid item xs={3}>
                        <TextLengthSelect
                            label="Response Length:"
                            value={selectedTextLength}
                            onChange={handleTextLengthChange}
                            error={selectTextLengthError}
                            fullWidth={false}
                        />
                    </Grid>
                ) : null}
                {includeTone.includes(selectFieldValue) ? (
                    <Grid item xs={3}>
                        <TextToneSelect
                            label="Response Tone:"
                            value={selectedTextTone}
                            onChange={handleTextToneChange}
                            error={selectTextToneError}
                            fullWidth={false}
                        />
                    </Grid>
                ) : null}
            </Grid>
            <Grid item xs={12}>
                <Button variant="contained" color="primary" onClick={handleClick} endIcon={<SendIcon />}>
                    Submit
                </Button>
            </Grid>
            {showModal && (
                <DialogComponent
                    open={showModal.open}
                    handleClose={() => setShowModal({ ...showModal, open: false })}
                    title={showModal.title}
                    description={showModal.description}
                >
                    {showModal.children}
                </DialogComponent>
            )}              
            </>
        }
        <Grid item xs={10} sx={{paddingTop: '0px !important'}}>
            {!apiResponse && loading && showForm ? (
                <div style={{ textAlign: 'center' }}>
                    <CircularProgress />
                </div>
            ) : (
                <HtmlRenderer 
                    html={apiResponse} 
                    onClear={handleClear} 
                    show={showHtmlRenderer} 
                    onAddNote={handleAddNoteClick} 
                    selectedMenuItem={selectFieldValue} 
                    onAddType={handleAddType}
                    onAddPriority={handleAddPriority}
                    onAddBoard={handleAddBoard}
                    onAddTeam={handleAddTeam}
                    onAddAgreement={handleAddAgreement}
                    onAddTitle={handleAddTitle}
                    showSentiment={sentiment}
                    sentimentRating={sentimentRating}
                    onHandleOpenWindow={handleOpenWindow}
                    onUpdateTicket={handleUpdateSentiment}
                />
            )}
        </Grid>
    </Grid>
  );
}
export default PsaAiBot;